import * as Oidc from 'oidc-client';

export const PortaInit = async () => {
    // Set the OpenID Connect authority URL
    const oidcAuthorityUrl = 'https://login.cncenter.cz/';
    // Get the current webpage URL
    const currentPageUrl = window.location.href;
    // Define client IDs for authentication based on webpage URL
    let clientId = '#';
    // Set the redirect URI after successful authentication
    let redirectUri = '#';
    if (currentPageUrl.includes('blesk.cz')) {
        clientId = 'BleskWdev_8502447c-c9cf-4ad9-9c69-614aeebd9f4e'; // Tento klic dostavame od porty a je primo jenom pro Blesk
        redirectUri = `https://www.blesk.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl + (currentPageUrl.includes('?') ? '&' : '?') + 'loginType=GoogleOneTap')}`;
    } else if (currentPageUrl.includes('blesk.local')) {
        clientId = '9fdc0bac-a9de-4662-8f0c-19d7430902af'; // Tento klic dostavame od porty a je primo jenom pro dew prostredi
        redirectUri = `https://www.blesk.cz/prihlaseni/login/porta?redirect_uri=${encodeURIComponent(currentPageUrl + (currentPageUrl.includes('?') ? '&' : '?') + 'loginType=GoogleOneTap')}`;
    }
    // Define client ID for authentication
    const dataclientId = '724554886791-45p9r05mklnbvama9srjsu614uis17vg.apps.googleusercontent.com'; // Master key from Google Develop console
    // Specify the response type for authentication
    const responseType = 'code';
    // Define the scope of requested user information and access
    const scope = 'cnc.myaccount offline_access openid email profile';
    // Create a new instance of the Oidc.UserManager with provided settings
    const userManager = new Oidc.UserManager({
        authority: oidcAuthorityUrl,
        client_id: clientId,
        redirect_uri: redirectUri,
        response_type: responseType,
        scope: scope,
    });
    let generatedUrl;
    // Create a signin request using the userManager
    const signinRequest = await userManager.createSigninRequest();
    // Check if url exists in response
    if (signinRequest?.url) {
        // Parse the URL of the signin request
        const url = new URL(signinRequest?.url);
        // Get the params of the parsed url
        const params = new URLSearchParams(url.search.substring(1));
        generatedUrl = `${oidcAuthorityUrl}ExternalLogin/ExternalLogin?provider=Google&returnUrl=${encodeURIComponent(`/connect/authorize/callback?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=${params.get('state')}&code_challenge=${params.get('code_challenge')}&code_challenge_method=${params.get('code_challenge_method')}&response_mode=${params.get('response_mode')}`)}`;
    }
    // Creating a div element for Google Sign-In configuratio
    const googleDiv = document.createElement('div');
    googleDiv.id = 'g_id_onload';
    googleDiv.setAttribute('data-client_id', dataclientId);
    googleDiv.setAttribute('data-login_uri', generatedUrl || '');
    googleDiv.setAttribute('data-cancel_on_tap_outside', 'false');
    document.body.appendChild(googleDiv);
    // Create a script element for Google Sign-In
    const googleScript = document.createElement('script');
    googleScript.src = 'https://accounts.google.com/gsi/client';
    googleScript.async = true;
    googleScript.defer = true;
    // Append the script element to the document's head
    document.body.appendChild(googleScript);
};
